import React from "react";
import { motion } from "framer-motion";

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3, 
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
};

function Who() {
  return (
    <motion.div
      className="px-6 sm:px-24 py-20 grid sm:grid-cols-2 gap-5"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.2 }} 
    >
      {[
        {
          title: "Who we are",
          text: "At HalalWealth, we empower you to invest in businesses and projects that reflect your values. Our carefully selected opportunities focus on environmental sustainability, social responsibility, and ethical business practices. Together, we can build a future where financial success aligns with positive impact, allowing you to grow your wealth while contributing to meaningful change.",
        },
        {
          title: "Our Mission",
          text: "To empower ethically conscious individuals and communities to build wealth through halal, interest-free financial systems.",
        },
        {
          title: "Our Vision",
          text: "A world where every Muslim - regardless of income level - has access to tools for responsible saving, collaborative investing, and financial growth without compromise.",
        },
        {
          title: "Our Difference",
          text: "We are not just a fintech. We're a community-first, Shariah-rooted wealth platform designed for impact - not just income.",
        },
        {
          title: "Transparency at Our Core",
          text: "No gimmicks, no vague fees, no riba. We exist to restore trust in how Muslims interact with money.",
        },
        {
          title: "Powered by Community",
          text: "Halal Wealth thrives on collective action - from Savings Pods to Investment Pods to referral-based growth. We rise by lifting each other.",
        },
      ].map((item, i) => (
        <motion.div key={i} variants={itemVariants}>
          <h1 className="text-primary-color font-[400] text-[20px] sm:text-[40px] mb-4">
            {item.title}
          </h1>
          <p className="text-[14px] sm:text-[16px] text-text-color1 font-medium mb-4">
            {item.text}
          </p>
        </motion.div>
      ))}
    </motion.div>
  );
}

export default Who;
